// Matches data_base/llm2/prompts/style_labels.txt; available before registration.
// §0.2: «Спокойно и аналитично» is selected on the style screen by default.
export const DEFAULT_STYLE = 'analytic'
export const COMMUNICATION_STYLES: Record<string, { label: string; hint: string }> = {
  soft: {
    label: 'Мягко и поддерживающе',
    hint: 'Слушаю без оценок — можно говорить даже о неприятном',
  },
  analytic: {
    label: 'Спокойно и аналитично',
    hint: 'Помогаю разложить всё по полочкам и увидеть, что происходит',
  },
  challenge: {
    label: 'С вызовом',
    hint: 'Помогаю заметить то, что вы обходите, и сдвинуться с привычной позиции',
  },
}
